<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="product-information">
    <p
      id="tablist-1"
      class="visually-hidden"
    >
      Product Information
    </p>
    <div
      v-if="!isMobile"
      class="product-information__tabs-container"
    >
      <div
        class="product-information__tabs"
        role="tablist"
        aria-labelledby="tablist-1"
      >
        <button
          v-if="tabs.description"
          type="button"
          class="product-information__tabs-item h6"
          :class="tabClasses(0)"
          role="tab"
          :aria-selected="tabIsSelected(0)"
          aria-controls="tabpanel-0"
          @click="onTabClicked(0)"
        >
          {{ tabs.description.title }}
        </button>
        <button
          v-for="(tab) in tabsWithContent"
          :key="tab.index"
          type="button"
          class="product-information__tabs-item h6"
          :class="tabClasses(tab.index)"
          role="tab"
          :aria-selected="tabIsSelected(tab.index)"
          :aria-controls="`tabpanel-${tab.index}`"
          @click="onTabClicked(tab.index)"
        >
          {{ tab.title }}
        </button>
      </div>
      <transition
        class="product-information__tabs-content"
        name="fade"
        mode="out-in"
      >
        <div
          :key="selectedTab"
          class="product-information__tabs-content-wrapper"
        >
          <div
            :id="`tabpanel-${selectedTab}`"
            role="tabpanel"
            :aria-labelledby="`tab-${selectedTab}`"
            v-html="getContent"
          />
        </div>
      </transition>
    </div>
    <div v-else>
      <Accordion
        v-if="tabs.description"
        :heading="tabs.description.title"
        theme="footer"
      >
        <div v-html="tabs.description.content" />
      </Accordion>
      <Accordion
        v-for="(tab, index) in tabsWithContent"
        :key="index"
        :heading="tab.title"
        theme="footer"
      >
        <div v-html="tab.content" />
      </Accordion>
    </div>
  </div>
</template>

<script>
  import Accordion from 'scripts/components/basic/Accordion.vue';

  export default {
    components: {
      Accordion,
    },

    props: {
      tabs: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        selectedTab: 0,
      };
    },

    computed: {
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },

      getContent() {
        return this.selectedTab === 0 ? this.tabs.description.content : this.tabs.tabs[this.selectedTab - 1].content;
      },

      tabsWithContent() {
        return this.tabs.tabs.filter((tab) => tab.content);
      },
    },

    mounted() {
      this.setInitialSelectedTab();
    },

    methods: {
      onTabClicked(index) {
        this.selectedTab = index;
      },

      setInitialSelectedTab() {
        if (this.tabs.description) {
          this.selectedTab = 0;
        } else if (this.tabs.tabs.length > 0) {
          this.selectedTab = 1;
        }
      },

      tabClasses(index) {
        return {
          active: this.tabIsSelected(index),
        };
      },

      tabIsSelected(index) {
        return this.selectedTab === index;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
